<template>
  <div>
    <customerChildDetail :tabType="tabType" v-if="tabType" />
    <customerDetail :tabName="activeName"  v-else/>
  </div>
</template>

<script>
import customerDetail from './pages/customerDetail/index.vue'
import customerChildDetail from './pages/customerChildDetail/index.vue'

export default {
  name: 'detail',
  components: {
    customerDetail,
    customerChildDetail,
  },
  data() {
    return {
      tabType: '', // 用来处理展示子订单详情页
      activeName: '', // 用来处理返回到对应tab
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to && to.query && to.query.tabType) {
          this.tabType = to.query.tabType
          this.activeName = ''
        } else if (from && from.query && from.query.tabType) {
          this.tabType = ''
          this.activeName = from.query.tabType || ''
        } else {
          this.tabType = ''
          this.activeName = ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style>

</style>
